import {
    Document,
    Page,
    Text,
    View,
    StyleSheet,
} from "@react-pdf/renderer";


/*
|--------------------------------------------------------------------------
| PDF STYLES
|--------------------------------------------------------------------------
*/

const styles = StyleSheet.create({

    /*
    |--------------------------------------------------------------------------
    | PAGE
    |--------------------------------------------------------------------------
    */

    page: {

        paddingTop: 26,

        paddingBottom: 36,

        paddingHorizontal: 30,

        fontSize: 8.5,

        color: "#111827",

        backgroundColor: "#ffffff",

    },


    /*
    |--------------------------------------------------------------------------
    | MAIN CONTENT
    |--------------------------------------------------------------------------
    */

    content: {

        width: "100%",

    },


    /*
    |--------------------------------------------------------------------------
    | HEADER
    |--------------------------------------------------------------------------
    */

    header: {

        marginBottom: 10,

        paddingBottom: 9,

        borderBottomWidth: 1.5,

        borderBottomColor: "#111827",

    },


    schoolName: {

        fontSize: 17,

        fontWeight: 700,

        marginBottom: 4,

    },


    reportTitle: {

        fontSize: 12.5,

        fontWeight: 700,

        marginBottom: 3,

    },


    subtitle: {

        fontSize: 7.5,

        color: "#6b7280",

        marginBottom: 8,

    },


    headerMeta: {

        flexDirection: "row",

        justifyContent: "space-between",

        alignItems: "center",

    },


    yearBox: {

        width: "35%",

        paddingVertical: 6,

        paddingHorizontal: 8,

        borderWidth: 0.8,

        borderColor: "#d1d5db",

        borderRadius: 3,

    },


    yearLabel: {

        fontSize: 6.2,

        color: "#6b7280",

        marginBottom: 2,

    },


    yearValue: {

        fontSize: 9.5,

        fontWeight: 700,

    },


    reportDescription: {

        width: "60%",

        textAlign: "right",

        fontSize: 6.8,

        color: "#6b7280",

        lineHeight: 1.4,

    },


    /*
    |--------------------------------------------------------------------------
    | SECTION
    |--------------------------------------------------------------------------
    */

    section: {

        width: "100%",

        marginBottom: 10,

    },


    sectionTitle: {

        fontSize: 9.8,

        fontWeight: 700,

        marginBottom: 6,

        paddingBottom: 3,

        borderBottomWidth: 0.8,

        borderBottomColor: "#d1d5db",

    },


    /*
    |--------------------------------------------------------------------------
    | SUMMARY
    |--------------------------------------------------------------------------
    */

    summaryGrid: {

        width: "100%",

        flexDirection: "row",

        justifyContent: "space-between",

    },


    summaryCard: {

        width: "24%",

    },


    summaryCardInner: {

        minHeight: 68,

        paddingVertical: 8,

        paddingHorizontal: 8,

        borderWidth: 0.8,

        borderColor: "#d1d5db",

        borderRadius: 3,

    },


    summaryLabel: {

        fontSize: 6.2,

        color: "#6b7280",

        marginBottom: 4,

    },


    summaryValue: {

        fontSize: 12,

        fontWeight: 700,

        marginBottom: 4,

    },


    summaryDescription: {

        fontSize: 6.2,

        color: "#6b7280",

        lineHeight: 1.3,

    },


    /*
    |--------------------------------------------------------------------------
    | CASH BALANCE
    |--------------------------------------------------------------------------
    */

    balanceGrid: {

        width: "100%",

        flexDirection: "row",

        justifyContent: "space-between",

    },


    balanceCard: {

        width: "49.3%",

    },


    balanceCardInner: {

        minHeight: 64,

        paddingVertical: 8,

        paddingHorizontal: 9,

        borderWidth: 1.2,

        borderColor: "#111827",

        borderRadius: 3,

    },


    /*
    |--------------------------------------------------------------------------
    | FORMULA
    |--------------------------------------------------------------------------
    */

    formulaBox: {

        width: "100%",

        paddingVertical: 7,

        paddingHorizontal: 9,

        borderWidth: 0.8,

        borderColor: "#d1d5db",

        borderRadius: 3,

    },


    formulaGrid: {

        width: "100%",

        flexDirection: "row",

        justifyContent: "space-between",

    },


    formulaColumn: {

        width: "49%",

    },


    formulaTitle: {

        fontSize: 7.2,

        fontWeight: 700,

        marginBottom: 3,

    },


    formulaText: {

        fontSize: 6.6,

        lineHeight: 1.35,

        marginBottom: 2,

    },


    /*
    |--------------------------------------------------------------------------
    | TABLE
    |--------------------------------------------------------------------------
    */

    table: {

        width: "100%",

        borderWidth: 0.8,

        borderColor: "#d1d5db",

        borderRadius: 2,

    },


    tableHeader: {

        width: "100%",

        flexDirection: "row",

        alignItems: "center",

        paddingVertical: 6,

        paddingHorizontal: 5,

        backgroundColor: "#111827",

    },


    tableRow: {

        width: "100%",

        flexDirection: "row",

        alignItems: "center",

        paddingVertical: 5,

        paddingHorizontal: 5,

        borderTopWidth: 0.5,

        borderTopColor: "#e5e7eb",

    },


    tableTotalRow: {

        width: "100%",

        flexDirection: "row",

        alignItems: "center",

        paddingVertical: 5.5,

        paddingHorizontal: 5,

        borderTopWidth: 0.8,

        borderTopColor: "#9ca3af",

        backgroundColor: "#f3f4f6",

    },


    /*
    |--------------------------------------------------------------------------
    | TABLE TEXT
    |--------------------------------------------------------------------------
    */

    headerText: {

        color: "#ffffff",

        fontSize: 7.2,

        fontWeight: 700,

        lineHeight: 1.1,

    },


    cellText: {

        fontSize: 7.2,

        lineHeight: 1.2,

    },


    amountText: {

        fontSize: 7.2,

        fontWeight: 700,

        textAlign: "right",

        lineHeight: 1.2,

    },


    /*
    |--------------------------------------------------------------------------
    | INCOME COLUMNS
    |--------------------------------------------------------------------------
    |
    | 60% + 20% + 20% = 100%
    |
    */

    incomeSource: {

        width: "60%",

        paddingRight: 5,

    },


    incomeLrd: {

        width: "20%",

        textAlign: "right",

        paddingLeft: 3,

    },


    incomeUsd: {

        width: "20%",

        textAlign: "right",

        paddingLeft: 3,

    },


    /*
    |--------------------------------------------------------------------------
    | EXPENDITURE COLUMNS
    |--------------------------------------------------------------------------
    |
    | 11% + 30% + 15% + 9% + 17% + 18% = 100%
    |
    */

    expenditureDate: {

        width: "11%",

        paddingRight: 4,

    },


    /*
    * This column now contains:
    *
    * 1. Expenditure title
    * 2. Expenditure description
    *
    * in the SAME table cell.
    */

    expenditureTitle: {

        width: "30%",

        paddingRight: 5,

    },


    expenditureCategory: {

        width: "15%",

        paddingRight: 4,

    },


    expenditureCurrency: {

        width: "9%",

        textAlign: "center",

        paddingHorizontal: 2,

    },


    expenditureAmount: {

        width: "17%",

        textAlign: "right",

        paddingLeft: 3,

    },


    expenditureReference: {

        width: "18%",

        paddingLeft: 4,

    },


    /*
    |--------------------------------------------------------------------------
    | EXPENDITURE TITLE
    |--------------------------------------------------------------------------
    */

    expenditureTitleText: {

        fontSize: 7.3,

        fontWeight: 700,

        lineHeight: 1.2,

        marginBottom: 2,

    },


    /*
    |--------------------------------------------------------------------------
    | EXPENDITURE DESCRIPTION
    |--------------------------------------------------------------------------
    */

    expenditureDescriptionText: {

        fontSize: 6.4,

        color: "#6b7280",

        lineHeight: 1.25,

    },


    /*
    |--------------------------------------------------------------------------
    | EMPTY TABLE
    |--------------------------------------------------------------------------
    */

    emptyText: {

        width: "100%",

        paddingVertical: 14,

        textAlign: "center",

        fontSize: 7.5,

        color: "#6b7280",

    },


    /*
    |--------------------------------------------------------------------------
    | NOTES
    |--------------------------------------------------------------------------
    */

    notesBox: {

        width: "100%",

        paddingVertical: 7,

        paddingHorizontal: 9,

        borderWidth: 0.8,

        borderColor: "#d1d5db",

        borderRadius: 3,

    },


    note: {

        fontSize: 6.6,

        lineHeight: 1.35,

        marginBottom: 3,

    },


    /*
    |--------------------------------------------------------------------------
    | FOOTER
    |--------------------------------------------------------------------------
    */

    footer: {

        position: "absolute",

        bottom: 10,

        left: 30,

        right: 30,

        height: 18,

        paddingTop: 4,

        borderTopWidth: 0.7,

        borderTopColor: "#d1d5db",

        flexDirection: "row",

        justifyContent: "space-between",

        alignItems: "center",

    },


    footerText: {

        fontSize: 6.3,

        color: "#6b7280",

    },

});


/*
|--------------------------------------------------------------------------
| SAFE NUMBER
|--------------------------------------------------------------------------
*/

const safeNumber = (value) => {

    const number = Number(value);

    return Number.isFinite(number)
        ? number
        : 0;

};


/*
|--------------------------------------------------------------------------
| FORMAT MONEY
|--------------------------------------------------------------------------
*/

const formatMoney = (value) => {

    return safeNumber(value).toLocaleString(
        "en-US",
        {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }
    );

};


/*
|--------------------------------------------------------------------------
| FORMAT DATE
|--------------------------------------------------------------------------
*/

const formatDate = (value) => {

    if (!value) {

        return "-";

    }

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {

        return String(value);

    }

    return date.toLocaleDateString(
        "en-US",
        {
            year: "numeric",
            month: "short",
            day: "2-digit",
        }
    );

};


/*
|--------------------------------------------------------------------------
| FORMAT CATEGORY
|--------------------------------------------------------------------------
*/

const formatCategory = (value) => {

    if (!value) {

        return "Other";

    }

    return String(value)
        .replaceAll("_", " ")
        .replace(
            /\b\w/g,
            (character) =>
                character.toUpperCase()
        );

};


/*
|--------------------------------------------------------------------------
| MAIN PDF COMPONENT
|--------------------------------------------------------------------------
*/

const DashboardForExpenditurePDF = ({
    financialData = {},
    expenditures = [],
    academicYear = null,
    generatedAt = new Date(),
}) => {


    /*
    |--------------------------------------------------------------------------
    | FINANCIAL DATA
    |--------------------------------------------------------------------------
    */

    const income =
        financialData?.income_statement ||
        {};


    const tuition =
        income?.tuition ||
        {};


    const scholarship =
        income?.scholarship ||
        {};


    const ward =
        income?.ward ||
        {};


    const totalIntake =
        income?.total_intake ||
        {};


    const totalExpenditure =
        income?.total_expenditure ||
        {};


    const cashBalance =
        income?.overall_cash_balance ||
        income?.available_cash ||
        {};


    /*
    |--------------------------------------------------------------------------
    | NORMALIZED VALUES
    |--------------------------------------------------------------------------
    */

    const lrdIntake =
        safeNumber(
            totalIntake?.lrd
        );


    const usdIntake =
        safeNumber(
            totalIntake?.usd
        );


    const lrdExpenditure =
        safeNumber(
            totalExpenditure?.lrd
        );


    const usdExpenditure =
        safeNumber(
            totalExpenditure?.usd
        );


    const lrdBalance =
        safeNumber(
            cashBalance?.lrd
        );


    const usdBalance =
        safeNumber(
            cashBalance?.usd
        );


    /*
    |--------------------------------------------------------------------------
    | DOCUMENT
    |--------------------------------------------------------------------------
    */

    return (

        <Document>


            {/* ==============================================================
                PAGE
            ============================================================== */}

            <Page
                size="A4"
                orientation="portrait"
                style={styles.page}
            >


                <View style={styles.content}>


                    {/* ======================================================
                        HEADER
                    ====================================================== */}

                    <View style={styles.header}>


                        <Text style={styles.schoolName}>
                            Excellent Kids Foundation - Financial Management
                        </Text>


                        <Text style={styles.reportTitle}>
                            Expenditure & Cash Flow Statement
                        </Text>


                        <Text style={styles.subtitle}>
                            Comprehensive academic-year expenditure and cash balance report
                        </Text>


                        <View style={styles.headerMeta}>


                            <View style={styles.yearBox}>

                                <Text style={styles.yearLabel}>
                                    ACADEMIC YEAR
                                </Text>


                                <Text style={styles.yearValue}>
                                    {
                                        academicYear?.name ||
                                        "Not specified"
                                    }
                                </Text>

                            </View>


                            <Text style={styles.reportDescription}>
                                Financial statement showing recorded income,
                                expenditure and available cash separately by currency.
                            </Text>


                        </View>


                    </View>


                    {/* ======================================================
                        FINANCIAL SUMMARY
                    ====================================================== */}

                    <View style={styles.section}>


                        <Text style={styles.sectionTitle}>
                            Financial Summary
                        </Text>


                        <View style={styles.summaryGrid}>


                            {/* LRD INTAKE */}

                            <View style={styles.summaryCard}>

                                <View style={styles.summaryCardInner}>

                                    <Text style={styles.summaryLabel}>
                                        TOTAL LRD INTAKE
                                    </Text>


                                    <Text style={styles.summaryValue}>
                                        LRD {formatMoney(lrdIntake)}
                                    </Text>


                                    <Text style={styles.summaryDescription}>
                                        Total school income received in LRD.
                                    </Text>

                                </View>

                            </View>


                            {/* USD INTAKE */}

                            <View style={styles.summaryCard}>

                                <View style={styles.summaryCardInner}>

                                    <Text style={styles.summaryLabel}>
                                        TOTAL USD INTAKE
                                    </Text>


                                    <Text style={styles.summaryValue}>
                                        USD {formatMoney(usdIntake)}
                                    </Text>


                                    <Text style={styles.summaryDescription}>
                                        Total school income received in USD.
                                    </Text>

                                </View>

                            </View>


                            {/* LRD EXPENDITURE */}

                            <View style={styles.summaryCard}>

                                <View style={styles.summaryCardInner}>

                                    <Text style={styles.summaryLabel}>
                                        LRD EXPENDITURE
                                    </Text>


                                    <Text style={styles.summaryValue}>
                                        LRD {formatMoney(lrdExpenditure)}
                                    </Text>


                                    <Text style={styles.summaryDescription}>
                                        Total expenditure paid using LRD.
                                    </Text>

                                </View>

                            </View>


                            {/* USD EXPENDITURE */}

                            <View style={styles.summaryCard}>

                                <View style={styles.summaryCardInner}>

                                    <Text style={styles.summaryLabel}>
                                        USD EXPENDITURE
                                    </Text>


                                    <Text style={styles.summaryValue}>
                                        USD {formatMoney(usdExpenditure)}
                                    </Text>


                                    <Text style={styles.summaryDescription}>
                                        Total expenditure paid using USD.
                                    </Text>

                                </View>

                            </View>


                        </View>

                    </View>


                    {/* ======================================================
                        OVERALL CASH BALANCE
                    ====================================================== */}

                    <View style={styles.section}>


                        <Text style={styles.sectionTitle}>
                            Overall Cash Balance
                        </Text>


                        <View style={styles.balanceGrid}>


                            {/* LRD */}

                            <View style={styles.balanceCard}>

                                <View style={styles.balanceCardInner}>

                                    <Text style={styles.summaryLabel}>
                                        AVAILABLE LRD CASH
                                    </Text>


                                    <Text style={styles.summaryValue}>
                                        LRD {formatMoney(lrdBalance)}
                                    </Text>


                                    <Text style={styles.summaryDescription}>
                                        Total LRD intake less LRD expenditure.
                                    </Text>

                                </View>

                            </View>


                            {/* USD */}

                            <View style={styles.balanceCard}>

                                <View style={styles.balanceCardInner}>

                                    <Text style={styles.summaryLabel}>
                                        AVAILABLE USD CASH
                                    </Text>


                                    <Text style={styles.summaryValue}>
                                        USD {formatMoney(usdBalance)}
                                    </Text>


                                    <Text style={styles.summaryDescription}>
                                        Total USD intake less USD expenditure.
                                    </Text>

                                </View>

                            </View>


                        </View>

                    </View>


                    {/* ======================================================
                        CURRENCY ACCOUNTING METHOD
                    ====================================================== */}

                    <View style={styles.section}>


                        <Text style={styles.sectionTitle}>
                            Currency Accounting Method
                        </Text>


                        <View style={styles.formulaBox}>


                            <View style={styles.formulaGrid}>


                                {/* LRD */}

                                <View style={styles.formulaColumn}>


                                    <Text style={styles.formulaTitle}>
                                        LRD Cash Calculation
                                    </Text>


                                    <Text style={styles.formulaText}>
                                        LRD Balance = LRD Total Intake - LRD Total Expenditure
                                    </Text>


                                    <Text style={styles.formulaText}>
                                        LRD {formatMoney(lrdIntake)}
                                        {" - "}
                                        LRD {formatMoney(lrdExpenditure)}
                                        {" = "}
                                        LRD {formatMoney(lrdBalance)}
                                    </Text>


                                </View>


                                {/* USD */}

                                <View style={styles.formulaColumn}>


                                    <Text style={styles.formulaTitle}>
                                        USD Cash Calculation
                                    </Text>


                                    <Text style={styles.formulaText}>
                                        USD Balance = USD Total Intake - USD Total Expenditure
                                    </Text>


                                    <Text style={styles.formulaText}>
                                        USD {formatMoney(usdIntake)}
                                        {" - "}
                                        USD {formatMoney(usdExpenditure)}
                                        {" = "}
                                        USD {formatMoney(usdBalance)}
                                    </Text>


                                </View>


                            </View>


                        </View>


                    </View>


                    {/* ======================================================
                        INCOME BREAKDOWN
                    ====================================================== */}

                    <View
                        style={styles.section}
                        wrap
                    >


                        <Text style={styles.sectionTitle}>
                            Income Breakdown
                        </Text>


                        <View style={styles.table}>


                            {/* HEADER */}

                            <View
                                style={styles.tableHeader}
                                fixed
                            >

                                <Text
                                    style={[
                                        styles.incomeSource,
                                        styles.headerText,
                                    ]}
                                >
                                    Revenue Source
                                </Text>


                                <Text
                                    style={[
                                        styles.incomeLrd,
                                        styles.headerText,
                                    ]}
                                >
                                    LRD
                                </Text>


                                <Text
                                    style={[
                                        styles.incomeUsd,
                                        styles.headerText,
                                    ]}
                                >
                                    USD
                                </Text>


                            </View>


                            {/* TUITION */}

                            <View
                                style={styles.tableRow}
                                wrap={false}
                            >

                                <Text
                                    style={[
                                        styles.incomeSource,
                                        styles.cellText,
                                    ]}
                                >
                                    Tuition
                                </Text>


                                <Text
                                    style={[
                                        styles.incomeLrd,
                                        styles.amountText,
                                    ]}
                                >
                                    {formatMoney(tuition?.lrd)}
                                </Text>


                                <Text
                                    style={[
                                        styles.incomeUsd,
                                        styles.amountText,
                                    ]}
                                >
                                    {formatMoney(tuition?.usd)}
                                </Text>


                            </View>


                            {/* SCHOLARSHIP */}

                            <View
                                style={styles.tableRow}
                                wrap={false}
                            >

                                <Text
                                    style={[
                                        styles.incomeSource,
                                        styles.cellText,
                                    ]}
                                >
                                    Scholarship
                                </Text>


                                <Text
                                    style={[
                                        styles.incomeLrd,
                                        styles.amountText,
                                    ]}
                                >
                                    {formatMoney(scholarship?.lrd)}
                                </Text>


                                <Text
                                    style={[
                                        styles.incomeUsd,
                                        styles.amountText,
                                    ]}
                                >
                                    {formatMoney(scholarship?.usd)}
                                </Text>


                            </View>


                            {/* WARD */}

                            <View
                                style={styles.tableRow}
                                wrap={false}
                            >

                                <Text
                                    style={[
                                        styles.incomeSource,
                                        styles.cellText,
                                    ]}
                                >
                                    Ward
                                </Text>


                                <Text
                                    style={[
                                        styles.incomeLrd,
                                        styles.amountText,
                                    ]}
                                >
                                    {formatMoney(ward?.lrd)}
                                </Text>


                                <Text
                                    style={[
                                        styles.incomeUsd,
                                        styles.amountText,
                                    ]}
                                >
                                    {formatMoney(ward?.usd)}
                                </Text>


                            </View>


                            {/* TOTAL */}

                            <View
                                style={styles.tableTotalRow}
                                wrap={false}
                            >

                                <Text
                                    style={[
                                        styles.incomeSource,
                                        styles.amountText,
                                    ]}
                                >
                                    TOTAL INTAKE
                                </Text>


                                <Text
                                    style={[
                                        styles.incomeLrd,
                                        styles.amountText,
                                    ]}
                                >
                                    {formatMoney(totalIntake?.lrd)}
                                </Text>


                                <Text
                                    style={[
                                        styles.incomeUsd,
                                        styles.amountText,
                                    ]}
                                >
                                    {formatMoney(totalIntake?.usd)}
                                </Text>


                            </View>


                        </View>


                    </View>


                    {/* ======================================================
                        EXPENDITURE DETAILS
                    ====================================================== */}

                    <View
                        style={styles.section}
                        wrap
                    >


                        <Text style={styles.sectionTitle}>
                            Expenditure Details
                        </Text>


                        <View style={styles.table}>


                            {/* =================================================
                                REPEATING TABLE HEADER
                            ================================================= */}

                            <View
                                style={styles.tableHeader}
                                fixed
                            >


                                <Text
                                    style={[
                                        styles.expenditureDate,
                                        styles.headerText,
                                    ]}
                                >
                                    Date
                                </Text>


                                <Text
                                    style={[
                                        styles.expenditureTitle,
                                        styles.headerText,
                                    ]}
                                >
                                    Expenditure / Description
                                </Text>


                                <Text
                                    style={[
                                        styles.expenditureCategory,
                                        styles.headerText,
                                    ]}
                                >
                                    Category
                                </Text>


                                <Text
                                    style={[
                                        styles.expenditureCurrency,
                                        styles.headerText,
                                    ]}
                                >
                                    Currency
                                </Text>


                                <Text
                                    style={[
                                        styles.expenditureAmount,
                                        styles.headerText,
                                    ]}
                                >
                                    Amount
                                </Text>


                                <Text
                                    style={[
                                        styles.expenditureReference,
                                        styles.headerText,
                                    ]}
                                >
                                    Reference
                                </Text>


                            </View>


                            {/* =================================================
                                EXPENDITURE ROWS
                            ================================================= */}

                            {
                                expenditures.length > 0

                                    ? expenditures.map(
                                        (
                                            expenditure,
                                            index
                                        ) => (

                                            <View
                                                key={
                                                    expenditure?.id ||
                                                    `expenditure-${index}`
                                                }
                                                style={styles.tableRow}
                                                wrap={false}
                                            >


                                                {/* DATE */}

                                                <Text
                                                    style={[
                                                        styles.expenditureDate,
                                                        styles.cellText,
                                                    ]}
                                                >
                                                    {
                                                        formatDate(
                                                            expenditure?.expenditure_date
                                                        )
                                                    }
                                                </Text>


                                                {/* =================================================
                                                    EXPENDITURE TITLE + DESCRIPTION
                                                    SAME TABLE CELL
                                                ================================================= */}

                                                <View
                                                    style={
                                                        styles.expenditureTitle
                                                    }
                                                >

                                                    <Text
                                                        style={
                                                            styles.expenditureTitleText
                                                        }
                                                    >
                                                        {
                                                            expenditure?.title ||
                                                            "-"
                                                        }
                                                    </Text>


                                                    {
                                                        expenditure?.description ? (

                                                            <Text
                                                                style={
                                                                    styles.expenditureDescriptionText
                                                                }
                                                            >
                                                                Description:{" "}
                                                                {
                                                                    expenditure.description
                                                                }
                                                            </Text>

                                                        ) : (

                                                            <Text
                                                                style={
                                                                    styles.expenditureDescriptionText
                                                                }
                                                            >
                                                                Description: No description provided
                                                            </Text>

                                                        )
                                                    }

                                                </View>


                                                {/* CATEGORY */}

                                                <Text
                                                    style={[
                                                        styles.expenditureCategory,
                                                        styles.cellText,
                                                    ]}
                                                >
                                                    {
                                                        expenditure?.category_display ||
                                                        formatCategory(
                                                            expenditure?.category
                                                        )
                                                    }
                                                </Text>


                                                {/* CURRENCY */}

                                                <Text
                                                    style={[
                                                        styles.expenditureCurrency,
                                                        styles.cellText,
                                                    ]}
                                                >
                                                    {
                                                        expenditure?.currency ||
                                                        "-"
                                                    }
                                                </Text>


                                                {/* AMOUNT */}

                                                <Text
                                                    style={[
                                                        styles.expenditureAmount,
                                                        styles.amountText,
                                                    ]}
                                                >

                                                    {
                                                        expenditure?.currency ===
                                                        "USD"
                                                            ? "$ "
                                                            : "LRD "
                                                    }

                                                    {
                                                        formatMoney(
                                                            expenditure?.amount
                                                        )
                                                    }

                                                </Text>


                                                {/* REFERENCE */}

                                                <Text
                                                    style={[
                                                        styles.expenditureReference,
                                                        styles.cellText,
                                                    ]}
                                                >
                                                    {
                                                        expenditure?.reference_number ||
                                                        expenditure?.receipt_number ||
                                                        "-"
                                                    }
                                                </Text>


                                            </View>

                                        )
                                    )

                                    : (

                                        <Text style={styles.emptyText}>
                                            No expenditure records were found for this report.
                                        </Text>

                                    )
                            }


                        </View>


                    </View>


                    {/* ======================================================
                        FINANCIAL NOTES
                    ====================================================== */}

                    <View style={styles.section}>


                        <Text style={styles.sectionTitle}>
                            Financial Notes
                        </Text>


                        <View style={styles.notesBox}>


                            <Text style={styles.note}>
                                • LRD income is maintained separately from USD income.
                            </Text>


                            <Text style={styles.note}>
                                • LRD expenditures are deducted only from the LRD cash balance.
                            </Text>


                            <Text style={styles.note}>
                                • USD expenditures are deducted only from the USD cash balance.
                            </Text>


                            <Text style={styles.note}>
                                • No currency conversion is performed when calculating cash balances.
                            </Text>


                            <Text style={styles.note}>
                                • A negative balance means recorded expenditures exceed recorded income for that currency.
                            </Text>


                        </View>


                    </View>


                </View>


                {/* ==========================================================
                    FOOTER
                ========================================================== */}

                <View
                    style={styles.footer}
                    fixed
                >


                    <Text style={styles.footerText}>
                        Academic Year:{" "}
                        {
                            academicYear?.name ||
                            "-"
                        }
                    </Text>


                    <Text style={styles.footerText}>
                        Generated:{" "}
                        {
                            formatDate(
                                generatedAt
                            )
                        }
                    </Text>


                    <Text style={styles.footerText}>
                        School Financial Management System
                    </Text>


                </View>


            </Page>

        </Document>

    );

};


export default DashboardForExpenditurePDF;

